var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3987_12778",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.859375,
    y: 15.0039,
    width: 20,
    height: 20,
    transform: "rotate(-45 0.859375 15.0039)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3987_12778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 23.8427L10.0511 17.8323L11.1117 16.7717L16.0615 21.7214L21.0112 16.7717L22.0719 17.8323L16.0615 23.8427ZM16.0615 18.1859L10.0511 12.1755L11.1117 11.1148L16.0615 16.0646L21.0112 11.1148L22.0719 12.1755L16.0615 18.1859Z",
    fill: "#FF6B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowsDown);
export default __webpack_public_path__ + "static/media/double_arrows_down.09c6fa15f49b5c54b7534d1a50d602a5.svg";
export { ForwardRef as ReactComponent };